<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <h4>List of Quotation Grade</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New Quotation Grade"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>

        <QuotationGradesTable
          :key="quotationGradesKey"
          :quotationGrades="quotationGrades"
          :loading="loading"
          @edit-quotationGrade="editQuotationGrade"
          @delete-quotationGrade="deleteQuotationGrade"
        />

        <QuotationGradesForm
          :quotationGradeToEdit="quotationGrade"
          :key="quotationGradesFormKey"
          :quotationGradesForm="quotationGradesForm"
          :sendingRequest="sendingRequest"
          :disabledArr="disabledArr"
          @close="quotationGrade = {}, quotationGradesForm = false"
          @save="saveQuotationGrade"
        />

      </div>
    </div>
  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";

import QuotationGradesTable from './QuotationGradesTable'
import QuotationGradesForm from './QuotationGradesForm'

export default {
  components: {
    QuotationGradesTable,
    QuotationGradesForm
  },
  data: () => ({
    opportunityService: new OpportunityService(),
    filters: '',
    quotationGradesKey1: 0,
    quotationGrades: [],
    quotationGradesForm: false,
    quotationGradesFormKey1: 0,
    disabledArr: [],
    quotationGrade: {},
    requesting: false,
    sendingRequest: false
  }),
  computed: {
    quotationGradesKey: {
      set(val) {
        this.quotationGradesKey1++
      },
      get() {
        return 'quotationGradesTable' + this.quotationGradesKey1.toString()
      }
    },
    quotationGradesFormKey: {
      set(val) {
        this.quotationGradesFormKey1++
      },
      get() {
        return 'quotationGradesForm' + this.quotationGradesFormKey1.toString()
      }
    },
    loading() {
      if (this.quotationGrades && this.quotationGrades[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.getAllQuotationGradesByHard()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  watch: {
    filters(val) {
      this.quotationGradesKey++
    },
    quotationGradesForm(val) {
      this.quotationGradesFormKey++
    },
    quotationGrades(val) {
      if (val && Array.isArray(val)) {
        this.quotationGradesKey++
      }
    }
  },
  methods: {
    deleteQuotationGrade(quotationGrade) {
      if (quotationGrade && quotationGrade.id) {
        this.opportunityService
          .deleteQuotationGrade(quotationGrade.id)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Quotation Grade deleted",
              detail: "Quotation Grade updated deleted.",
              life: 5000,
            });
          
            this.quotationGradesForm = false
            this.getAllQuotationGradesByHard()
            this.getAllActiveQuotationGradesByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while deleting Quotation Grade",
              life: 5000,
            })
          })
      }
    },
    editQuotationGrade(quotationGrade) {
      
      this.quotationGrade = quotationGrade
      this.quotationGradesForm = true
    },
    saveQuotationGrade(quotationGrade) {
      

      this.sendingRequest = true

      if (quotationGrade.id) {

        this.opportunityService
          .editQuotationGrade(quotationGrade)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Quotation Grade updated",
              detail: "Quotation Grade updated successfully.",
              life: 5000,
            });
          
            this.sendingRequest = false
            this.quotationGradesForm = false
            this.getAllQuotationGradesByHard()
            this.getAllActiveQuotationGradesByHard()
          })
          .catch(err => {
            this.sendingRequest = false
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating Quotation Grade",
              life: 5000,
            })
          })
      } else {
        this.opportunityService
          .saveQuotationGrade(quotationGrade)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Quotation Grade saved",
              detail: "Quotation Grade saved successfully.",
              life: 5000,
            })
          
            this.sendingRequest = false
            this.quotationGradesForm = false
            this.getAllQuotationGradesByHard()
            this.getAllActiveQuotationGradesByHard()
          })
          .catch(err => {
            this.sendingRequest = false
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving Quotation Grade",
              life: 5000,
            })
          })
      }
    },
    getAllQuotationGradesByHard() {
      this.requesting = true
      this.opportunityService
        .getAllQuotationGradesByHard()
        .then(data => {
          this.requesting = false
          this.quotationGrades = data
        })
        .catch(err => {
          this.requesting = false
          
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting Quotation Grade",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "quotationGrades"'
          })
        })
    },
    getAllActiveQuotationGradesByHard() {
      this.opportunityService
        .getAllActiveQuotationGradesByHard()
        .then(data => {})
        .catch(err => {
          

          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "activeQuotationGrades"'
          })
        })
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
    openNew() {
      this.quotationGrade = {}
      this.quotationGradesForm = true
    }
  }
}
</script>

<style>

</style>